import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { translate } from '@/i18n';
import { showToast } from '@/utils';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonTitle,
  IonToolbar,
  modalController,
} from '@ionic/vue';
import { closeOutline, saveOutline } from 'ionicons/icons';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: ["accountType"],
  setup(__props) {

const props = __props



const loopDetails = ref({
  privateKey: '',
  sendSharedSecret: '',
  accountType: props.accountType
});

const cancel = () => modalController.dismiss(null, 'cancel');
const confirm = () => {
  if (!loopDetails.value.privateKey.trim() || !loopDetails.value.sendSharedSecret.trim()) {
    showToast(translate("Please fill in all fields before saving."));
    return;
  } else {
    modalController.dismiss(loopDetails.value, 'save')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  color: "medium",
                  onClick: cancel
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), { icon: _unref(closeOutline) }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)(props.accountType == "sandbox" ? "Add Loop Sandbox" : "Add Loop Production")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonItem), { lines: "full" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInput), {
              "label-placement": "floating",
              label: _unref(translate)('API Key'),
              modelValue: loopDetails.value.privateKey,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loopDetails.value.privateKey) = $event)),
              type: "text",
              required: ""
            }, null, 8, ["label", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonItem), { lines: "full" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInput), {
              "label-placement": "floating",
              label: _unref(translate)('Webhook Secret'),
              modelValue: loopDetails.value.sendSharedSecret,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loopDetails.value.sendSharedSecret) = $event)),
              type: "text",
              required: ""
            }, null, 8, ["label", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonFab), {
          horizontal: "end",
          vertical: "bottom",
          slot: "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonFabButton), { onClick: confirm }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})